import { AccountObjectApiFacade } from "../account-object/account-object.api-facade";
import { Field } from "./field.model";
import { Observable } from "rxjs/Observable";
import { ApiRequestOptions } from "../../../core/services/api/request-options";

export class FieldApiFacade extends AccountObjectApiFacade<Field> {

    get(accountId: string, jobId: string, id: string, options?: ApiRequestOptions): Observable<Field> {
        return this.GET(`/accounts/${accountId}/jobs/${jobId}/fields/${id}`, options)
            .map(object => new Field(object));
    }

    getAll(accountId: string, jobId: string, options?: ApiRequestOptions): Observable<Array<Field>> {
        return this.CGET(`/accounts/${accountId}/jobs/${jobId}/fields`, options)
            .map(objects => objects.map(object => new Field(object)));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/field/field.api-facade.ts